// HTTP 201 also carries a request for ELT/GL confirmation; it is not proof of persistence.
export async function finalizarPedidoOperacaoConfirmado(payload, enviar) {
  const response = await enviar(payload);
  if (response?.data?.precisaDividirCategorias) {
    throw new Error('O servidor solicitou uma divisão incompatível com o pedido único. Nenhuma divisão foi confirmada; os itens foram preservados.');
  }
  const body = response?.data;
  const ids = Array.isArray(body?.pedidos)
    ? body.pedidos.map(pedido => pedido?.pedidoid)
    : [body?.data?.pedidoid || body?.pedidoid];
  const validos = ids.every(id => Number.isSafeInteger(Number(id)) && Number(id) > 0);
  if (!body || body.success === false || body.precisaDividirCategorias || !validos
    || ids.length !== 1 || new Set(ids.map(String)).size !== ids.length) {
    throw new Error('O servidor não confirmou os números dos pedidos. Os itens foram preservados. Consulte a lista antes de tentar novamente para evitar duplicidade.');
  }
  return { response, ids: ids.map(Number) };
}
